import { Overlay } from '@eti/components';
import { useEffect, useState } from 'react';
import { getCheapestUpgradeSegments, selectedSegmentUpgradeTotalPrice } from '../../utils/utils';
import { CABIN_UPGRADE } from '../../../products';
import CabinUpgradeSelection from './CabinUpgradeSelection';
import CabinUpgradeSummary from './CabinUpgradeSummary';
import CabinUpgradeContentInfoCard from './CabinUpgradeContentInfoCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CabinUpgradeDrawer = _ref => {
  let {
    availabilityTexts,
    isOpen,
    isUpgradeSelected,
    segmentUpgradeList,
    setIsDrawerOpen,
    updateSelectedCabinUpgrades
  } = _ref;
  const initialSelectedOptions = segmentUpgradeList !== null && segmentUpgradeList !== void 0 && segmentUpgradeList.length ? getCheapestUpgradeSegments(segmentUpgradeList) : {};
  const [selectedOptions, setSelectedOptions] = useState(initialSelectedOptions);
  useEffect(() => {
    if (!isUpgradeSelected) {
      setSelectedOptions(initialSelectedOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpgradeSelected]);
  const totalPrice = selectedSegmentUpgradeTotalPrice(Object.values(selectedOptions));
  const onClose = () => {
    setIsDrawerOpen(false);
    if (!isUpgradeSelected) {
      const selection = {
        value: '',
        selectedUpgrades: [],
        priceRaw: totalPrice
      };
      updateSelectedCabinUpgrades(selection);
      setTimeout(() => {
        var _document$getElementB;
        (_document$getElementB = document.getElementById(`${CABIN_UPGRADE.name}_true`)) === null || _document$getElementB === void 0 || _document$getElementB.blur();
      }, 100);
    }
  };
  const onSave = () => {
    const selectedUpgrades = Object.values(selectedOptions);
    const selection = {
      value: selectedUpgrades !== null && selectedUpgrades !== void 0 && selectedUpgrades.length ? 'true' : 'false',
      selectedUpgrades,
      priceRaw: totalPrice
    };
    updateSelectedCabinUpgrades(selection);
    setIsDrawerOpen(false);
    if (!(selectedUpgrades !== null && selectedUpgrades !== void 0 && selectedUpgrades.length)) {
      var _document$getElementB2;
      (_document$getElementB2 = document.getElementById(`${CABIN_UPGRADE.name}_false`)) === null || _document$getElementB2 === void 0 || _document$getElementB2.focus();
    }
  };
  const {
    drawerAdditionalContentText = [],
    drawerSaveButtonLabel,
    drawerTitle,
    drawerTotalPriceLabel
  } = (availabilityTexts === null || availabilityTexts === void 0 ? void 0 : availabilityTexts.drawer) || {};
  return /*#__PURE__*/_jsxs(Overlay.Drawer, {
    dataTestId: `${CABIN_UPGRADE.name}-drawer`,
    handleClose: onClose,
    isOpen: isOpen,
    shouldOpenHorizontally: true,
    children: [/*#__PURE__*/_jsx(Overlay.Header, {
      onClose: onClose,
      title: drawerTitle
    }), /*#__PURE__*/_jsxs(Overlay.Content, {
      "data-testid": `${CABIN_UPGRADE.name}-drawer-content`,
      children: [/*#__PURE__*/_jsx(CabinUpgradeSelection, {
        availabilityTexts: availabilityTexts,
        segmentUpgradeList: segmentUpgradeList,
        selectedOptions: selectedOptions,
        setSelectedOptions: setSelectedOptions
      }), /*#__PURE__*/_jsx(CabinUpgradeContentInfoCard, {
        drawerAdditionalContentText: drawerAdditionalContentText
      })]
    }), /*#__PURE__*/_jsx(Overlay.Footer, {
      children: /*#__PURE__*/_jsx(CabinUpgradeSummary, {
        buttonLabel: drawerSaveButtonLabel,
        onSave: onSave,
        totalPrice: totalPrice,
        totalPriceLabel: drawerTotalPriceLabel
      })
    })]
  });
};
export default CabinUpgradeDrawer;
//# sourceMappingURL=CabinUpgradeDrawer.js.map